import { Outlet, useLocation } from 'react-router-dom'
import { Box } from '@mui/material'

import { Navbar } from '@/components/navigation/Navbar'
import { Footer } from '@/components/navigation/Footer'
import { CookieBanner } from '@/components/ui/CookieBanner'
import { ScrollToTop } from '@/lib/ScrollToTop'

export const MainLayout = () => {
  const location = useLocation()
  const isHomePage = location.pathname === '/'
  const isProductionPage = location.pathname.startsWith('/production/')

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#000',
      }}
    >
      <ScrollToTop />
      <Navbar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: isHomePage || isProductionPage ? 0 : { xs: '64px', sm: '100px' },
        }}
      >
        <Outlet />
      </Box>
      <Footer />
      <CookieBanner />
    </Box>
  )
}
